// 화면 18 (Leader Stocks 45 Grid) REST 어댑터.
// 권위: docs/ARCH_DASHBOARD.md v1.10.3 §6.2 — 3 엔드포인트.
// 응답 envelope 은 client.ts interceptor 가 언랩.

import { apiGet } from '../../api/client';
import type {
  BandHistory,
  LeaderStocksDiff,
  LeaderStocksSnapshot,
  LookbackDays,
  OhlcvInterval,
  StockOhlcv,
} from './types';

// date 가 null 이면 미전송 → 서버가 max(trading_date) 폴백 (휴장/오늘 미적재 케이스).
export async function getLeaderStocksDaily(date: string | null): Promise<LeaderStocksSnapshot> {
  const qs = date ? `?${new URLSearchParams({ date }).toString()}` : '';
  return apiGet<LeaderStocksSnapshot>(`/api/v1/leading-stocks/daily${qs}`);
}

// v1.10.3: prev 는 정수 (1 | 5 | 30) 만. 날짜 문자열 / lookback 보조 파라미터 미사용.
export async function getLeaderStocksDiff(
  date: string,
  prevDays: LookbackDays
): Promise<LeaderStocksDiff> {
  const qs = new URLSearchParams({ date, prev: String(prevDays) }).toString();
  return apiGet<LeaderStocksDiff>(`/api/v1/leading-stocks/diff?${qs}`);
}

export async function getBandHistory(symbol: string, days = 60): Promise<BandHistory> {
  const qs = new URLSearchParams({ days: String(days) }).toString();
  return apiGet<BandHistory>(`/api/v1/leading-stocks/${symbol}/band-history?${qs}`);
}

// 캔들 차트용 OHLCV. days cap 은 백엔드에서 검증.
export async function getStockOhlcv(
  symbol: string,
  interval: OhlcvInterval,
  days: number
): Promise<StockOhlcv> {
  const qs = new URLSearchParams({ interval, days: String(days) }).toString();
  return apiGet<StockOhlcv>(`/api/v1/stocks/${symbol}/ohlcv?${qs}`);
}
